TEMPLATES =
  main: require '../main.html.mustache'

module.exports = class CrossSellBait

  constructor: ({ @$offers }) ->
    return if $('#multiple-offers').length > 0

    data =
      placeName: $('.mpp-container').data('place-name')
    data.t = data.translate = -> (str) -> I18n.t str
    @$el = $ TEMPLATES.main.render(data)

    @$overlay = @$el.find '.cross-sell-bait-hover'
    @$arrowCircle = @$overlay.find '.arrow-circle'
    @$arrowWrapper = @$overlay.find '.arrow-wrapper'

    @$el.click @click
    @$el.hover @mouseEnter, @mouseLeave

    $('body').append @$el
    @animate()

    @debounceScroll = null
    $(window).on 'scroll', @scrollHandler

  scrollHandler: =>
    clearTimeout(@debounceScroll) if @debounceScroll?
    @debounceScroll = setTimeout (=>
      if $(window).scrollTop() > $('.mpp-container .merchant-information-row').offset().top
        @$el.slideUp 'fast'
      else
        @$el.slideDown 'slow'
    ), 100

  click: =>
    @$overlay.hide()

    duration = 500
    $('html, body').animate {
      scrollTop: @$offers.offset().top - 10
    }, duration, =>
      @$el.slideUp 'fast'

  mouseEnter: =>
    @$overlay.show()
    @slideUp @$arrowCircle
    @slideUp @$arrowWrapper, 50

  mouseLeave: =>
    @$overlay.hide()
    @$arrowCircle.addClass('hidden').removeClass 'animate-slide-up'
    @$arrowWrapper.addClass('hidden').removeClass 'animate-slide-down'

  animate: ->
    @$el.slideDown 'fast', =>
    @slideDown @$el.find('.mpp-icon-map-pin-empty')
    @slideDown @$el.find('.mpp-icon-map-pin-star'), 100

    @slideDown @$el.find('.cross-sell-title'), 300
    @slideDown @$el.find('.cross-sell-place-name'), 300

    $icons = @$el.find '.cross-sell-bait-icons span'

    timeout = 500
    for icon in $icons
      @slideDown $(icon), timeout
      timeout += 100

  slideUp: (element, timeout = 0) ->
    setTimeout (=>
      $(element).addClass('animate-slide-up').removeClass('hidden')
    ), timeout

  slideDown: (element, timeout = 0) ->
    setTimeout (=>
      $(element).addClass('animate-slide-down').removeClass('hidden')
    ), timeout
